export const getErrorMessage = (error, fallback) => {
  if (!error) return null;
  if (typeof error === 'string') return error;
  if (typeof error === 'object') {
    if (error.detail) return error.detail;
    if (error.message) return error.message;
    if (error.status && error.message)
      return `Error ${error.status}: ${error.message}`;
  }
  return fallback;
};
